import { PriorityType, TaskActivity, Tasklist } from 'src/app/hickory-api';
import { Guid } from 'src/utility/guid';
import { DataGenerator } from './DataGenerator';

export class TasklistData extends DataGenerator<Tasklist> {
  static instance = new TasklistData();

  protected createPredefined(): Tasklist[] {
    const json: Tasklist[] = [{
      id: '4f4c',
      title: 'Pandemic Flu 497',
      description: 'New flu threat confirmed by CDC',
      createdOn: new Date(1488999622973),
      modifiedOn: new Date(1488999622973),
      owner: {
        id: 1234,
        externalId: 'employee1234',
        name: {
          givenName: 'Chester',
          familyName: 'Tester'
        }
      },
      assignees: [
        {
          id: 777,
          externalId: 'employee5378',
          name: {
            givenName: 'Tony',
            familyName: 'Stark'
          }
        },
        {
          id: 888,
          externalId: 'employee3591',
          name: {
            givenName: 'Wade',
            familyName: 'Watts'
          }
        }
      ],
      isActive: true,
      priority: PriorityType.Emergency,
      isComplete: false,
      totalTasks: 2,
      completedTasks: 1,
      tasks: [
        {
          id: '23d8',
          sequence: 1,
          title: 'London Fire - Call Fire Department',
          description: 'Push the buttons on the phone until the fire ' +
          'department phone starts ringing, then talk to them.',
          isComplete: true,
          isSkipped: false,
          activities: [
            {
              id: 'taskComment',
              type: TaskActivity.TypeEnum.Comment,
              comment: 'This is a comment on this task',
              assignee: {
                id: 777,
                externalId: 'employee5378',
                name: {
                  givenName: 'Tony',
                  familyName: 'Stark'
                }
              },
              timestamp: new Date(1488999622973)
            },
            {
              id: 'taskSkip',
              type: TaskActivity.TypeEnum.Skip,
              comment: 'This is a skip comment on this task',
              assignee: {
                id: 777,
                externalId: 'employee5378',
                name: {
                  givenName: 'Tony',
                  familyName: 'Stark'
                }
              },
              timestamp: new Date(1488999622973)
            },
            {
              id: 'taskLongComment',
              type: TaskActivity.TypeEnum.Comment,
              comment: 'This is a comment on this task with a longer piece of text that should reach the other side of the page and a little beyond so that it wraps to a new line.',
              assignee: {
                id: 777,
                externalId: 'employee5378',
                name: {
                  givenName: 'Tony',
                  familyName: 'Stark'
                }
              },
              timestamp: new Date(1488999622973)
            },
            {
              id: 'taskComplete',
              type: TaskActivity.TypeEnum.Complete,
              comment: 'This is marks the task complete',
              assignee: {
                id: 777,
                externalId: 'employee5378',
                name: {
                  givenName: 'Tony',
                  familyName: 'Stark'
                }
              },
              timestamp: new Date(1488999622973)
            }
          ]
        },
        {
          id: '9347',
          sequence: 2,
          title: 'Implement Viral Outbrak Policy and Proceedures',
          description: 'Run really fast',
          isComplete: false,
          isSkipped: true,
          activities: []
        }
      ]
    },
    {
      id: '4f4d',
      title: 'Earthquake',
      description: 'Earthquake happened',
      createdOn: new Date(1488999622973),
      modifiedOn: new Date(1488999622973),
      owner: {
        id: 1235,
        externalId: 'employee1234',
        name: {
          givenName: 'Chester',
          familyName: 'Tester'
        }
      },
      assignees: [
        {
          id: 778,
          externalId: 'employee5378',
          name: {
            givenName: 'Tony',
            familyName: 'Stark'
          }
        },
        {
          id: 889,
          externalId: 'employee3591',
          name: {
            givenName: 'Wade',
            familyName: 'Watts'
          }
        }
      ],
      priority: PriorityType.NonEmergency,
      isActive: true,
      isComplete: false,
      totalTasks: 2,
      completedTasks: 1,
      tasks: [
        {
          id: '23d9',
          sequence: 1,
          title: 'London Fire - Call Fire Department',
          description: 'Push the buttons on the phone until the fire ' +
          'department phone starts ringing, then talk to them.',
          isComplete: true,
          isSkipped: false,
          activities: []
        },
        {
          id: '9338',
          sequence: 2,
          title: 'Do earthquake stuff',
          description: 'Run really fast',
          isComplete: false,
          isSkipped: true,
          activities: []
        }]
    },
    {
      id: '5f5c',
      title: 'Pandemic Flu 497',
      description: 'New flu threat confirmed by CDC',
      createdOn: new Date(1488999622973),
      modifiedOn: new Date(1488999622973),
      owner: {
        id: 1234,
        externalId: 'employee1234',
        name: {
          givenName: 'Chester',
          familyName: 'Tester'
        }
      },
      assignees: [
        {
          id: 777,
          externalId: 'employee5378',
          name: {
            givenName: 'Tony',
            familyName: 'Stark'
          }
        },
        {
          id: 888,
          externalId: 'employee3591',
          name: {
            givenName: 'Wade',
            familyName: 'Watts'
          }
        }
      ],
      isActive: false,
      priority: PriorityType.Emergency,
      isComplete: true,
      totalTasks: 2,
      completedTasks: 2,
      tasks: [
        {
          id: '23c9',
          sequence: 1,
          title: 'London Fire - Call Fire Department',
          description: 'Push the buttons on the phone until the fire ' +
          'department phone starts ringing, then talk to them.',
          isComplete: true,
          isSkipped: false,
          activities: []
        },
        {
          id: '9339',
          sequence: 2,
          title: 'Implement Viral Outbrak Policy and Proceedures',
          description: 'Run really fast',
          isComplete: true,
          isSkipped: false,
          activities: []
        }
      ]
    },
    {
      id: '6f6d',
      title: 'Earthquake',
      description: 'Earthquake happened',
      createdOn: new Date(1488999622973),
      modifiedOn: new Date(1488999622973),
      owner: {
        id: 1235,
        externalId: 'employee1234',
        name: {
          givenName: 'Chester',
          familyName: 'Tester'
        }
      },
      assignees: [
        {
          id: 778,
          externalId: 'employee5378',
          name: {
            givenName: 'Tony',
            familyName: 'Stark'
          }
        },
        {
          id: 889,
          externalId: 'employee3591',
          name: {
            givenName: 'Wade',
            familyName: 'Watts'
          }
        }
      ],
      priority: PriorityType.Emergency,
      isActive: false,
      isComplete: true,
      totalTasks: 2,
      completedTasks: 2,
      tasks: [
        {
          id: '23c7',
          sequence: 1,
          title: 'London Fire - Call Fire Department',
          description: 'Push the buttons on the phone until the fire ' +
          'department phone starts ringing, then talk to them.',
          isComplete: true,
          isSkipped: false,
          activities: []
        },
        {
          id: '9337',
          sequence: 2,
          title: 'Do earthquake stuff',
          description: 'Run really fast',
          isComplete: true,
          isSkipped: true,
          activities: []
        }]
    }];
    return json;
  }

  protected createGenerated(): Tasklist[] {
    const list: Tasklist[] = [];
    for (let i = 0; i < 50; i++) {
      if (i % 2 === 0) {
        list.push(this.generate(i));
      } else {
        list.push(this.generateAlternate(i));
      }
    }
    return list;
  }

  private generate(i: number): Tasklist {
    let isComplete = false;
    let completedTasks: number = (2 + i % 8);
    const totalTasks: number = (2 + i % 10);
    if (completedTasks >= totalTasks) {
      completedTasks = totalTasks;
      isComplete = true;
    }

    return {
      id: 'g' + i,
      title: 'Generated Emergency Tasklist Title',
      description: 'Generated Emergency Tasklist Description',
      createdOn: new Date(1488999622985),
      modifiedOn: new Date(1488999622985),
      owner: {
        id: 1235,
        externalId: 'employee1234',
        name: {
          givenName: 'Chester',
          familyName: 'Tester'
        }
      },
      assignees: [
        {
          id: 888,
          externalId: 'employee3591',
          name: {
            givenName: 'Wade',
            familyName: 'Watts'
          }
        }
      ],
      priority: PriorityType.Emergency,
      isActive: !isComplete,
      isComplete: isComplete,
      totalTasks: totalTasks,
      completedTasks: completedTasks,
      tasks: [
        {
          id: '9339',
          sequence: 2,
          title: 'Implement Viral Outbrake Policy and Proceedures',
          description: 'Run really fast',
          isComplete: true,
          isSkipped: false,
          activities: []
        }]
    };
  }

  private generateAlternate(i: number): Tasklist {
    let isComplete = false;
    let completedTasks: number = (2 + i % 9);
    const totalTasks: number = (2 + i % 11);
    if (completedTasks >= totalTasks) {
      completedTasks = totalTasks;
      isComplete = true;
    }

    return {
      id: 'g' + i,
      title: 'Generated Operational Tasklist Title',
      description: 'Generated Operational Tasklist Description',
      createdOn: new Date(1488999622985),
      modifiedOn: new Date(1488999622985),
      owner: {
        id: 1235,
        externalId: 'employee1234',
        name: {
          givenName: 'Chester',
          familyName: 'Tester'
        }
      },
      assignees: [
        {
          id: 778,
          externalId: 'employee5378',
          name: {
            givenName: 'Tony',
            familyName: 'Stark'
          }
        }
      ],
      priority: PriorityType.NonEmergency,
      isActive: !isComplete,
      isComplete: isComplete,
      totalTasks: totalTasks,
      completedTasks: completedTasks,
      tasks: [
        {
          id: '23c7',
          sequence: 1,
          title: 'London Fire - Call Fire Department',
          description: 'Push the buttons on the phone until the fire ' +
          'department phone starts ringing, then talk to them.',
          isComplete: true,
          isSkipped: false,
          activities: []
        }]
    };
  }

  getActive(): Tasklist[] {
    return this.all.filter(t => t.isActive === true && t.isComplete === false);
  }

  getCompleted(): Tasklist[] {
    return this.all.filter(t => t.isActive === false && t.isComplete === true);
  }

  add(tasklist: Tasklist) {
    tasklist.id = Guid.newGuid().toString();
    this._manual.push(tasklist);
  }

  delete(id: string) {
    this._manual = this._manual.filter(i => i.id !== id);
    this._predefined = this._predefined.filter(i => i.id !== id);
    this._generated = this._generated.filter(i => i.id !== id);
  }
}
export const tasklistData = TasklistData.instance;
